export default __webpack_public_path__ + "pdf.ed1711b077b6139e.svg";